"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledBreadCrumbsItem = exports.StyledBreadCrumbs = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const theme_1 = require("@icr-ui/theme");
const flexbox_1 = require("../flexbox");
exports.StyledBreadCrumbs = (0, styled_components_1.default)(flexbox_1.Flexbox) `
  border-radius: ${theme_1.defaultTheme.borders.radius.card};
  transition: all 0.2s ease-in-out;
`;
exports.StyledBreadCrumbsItem = (0, styled_components_1.default)(flexbox_1.Flexbox) `
  cursor: pointer;
  p {
    color: ${theme_1.palette.grayScale[600]};
    padding: 4px;
  }

  &:hover {
    p {
      color: ${theme_1.palette.primary.dark};
    }
  }

  &:last-child {
    p {
      color: ${theme_1.palette.primary.light};
    }
  }

  &:focus-visible {
    p {
      border-radius: 4px;
      box-shadow: ${theme_1.shadows.containedFocus(theme_1.palette.primary.main, theme_1.palette.primary.main)};
      color: ${theme_1.palette.primary.dark};
    }
  }
`;
//# sourceMappingURL=styles.js.map